import React from 'react'
import AdmADHOCFee from "../../components/AdminTabs/AdminAdhocFees/AdmADHOCFee"

const AdhocFee = () => {
  return (
    <div>
        <AdmADHOCFee/>
    </div>
  )
}

export default AdhocFee